import { createFileRoute } from '@tanstack/react-router'
import ProjectDetailPage from '@/spa/pages/projects/ProjectDetailPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/')({
  component: ProjectDetailPage,
  errorComponent: routeErrorComponent,
})
